'use strict';

$(document).ready(function () {
    require('./customerService/contactForm').init();
});
